namespace Areas {
    "use strict";

    declare var CKEDITOR: any;
    let alreadyInitialized: boolean = false;

    export function ckeditorInit(elementId, height, readonly?) {
        if (CKEDITOR.instances[elementId]) {
            return;
        }

        if ($('#' + elementId).length > 0) {

            if (!alreadyInitialized) {
                CKEDITOR.plugins.addExternal('autolink', '/js/autolink/', 'plugin.js');
                var config: any = { extraPlugins: 'autolink', removeButtons: 'About' };
                if ($('#' + elementId).is('[readonly]') || readonly) {
                    config.toolbar = [['Copy', 'Maximize', 'Source']];
                }

                config.extraAllowedContent = 'ol[type]';
                config.height = height;

                if (readonly) config.readOnly = true;
                alreadyInitialized = true;
            }


            CKEDITOR.replace(elementId, config);
        }
    }

    export function ckeditorGet(elementId) {

        return CKEDITOR.instances[elementId].getData();
    }

    export function ckeditorSet(elementId, value) {

        CKEDITOR.instances[elementId].setData(value);
    }

    export function ckeditorClear(elementId) {
        if (CKEDITOR.instances[elementId]) {
            CKEDITOR.instances[elementId].destroy();
        }
    }

}